import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appPortalAiComplianceLink]',
  standalone: false,
})
export class PortalAiComplianceLinkDirective {
  @HostListener('click')
  onClick(): void {
    window.open('https://techspert.com/ai-compliance-statement', '_blank');
  }
}
